import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { CommandMetadataContent } from './command-component';
import { ServiceMetadataContent } from './service-component';

@Injectable()
export class CommandMetadataService {

  private commandMetatadataContentCache: Map<string, CommandMetadataContent> = new Map();

  private serviceMetatadataContentCache: Map<string, ServiceMetadataContent> = new Map();

  constructor(private httpClient: HttpClient) {
  }

  public getCommandMetadataContent(id: string): Observable<CommandMetadataContent> {
    if (this.commandMetatadataContentCache.has(id)) {
      return of(this.commandMetatadataContentCache.get(id));
    }
    const controllerUri = `/platform/common/web/@farris/controllers/${id}.json`;
    return this.httpClient.get(controllerUri)
      .pipe(
        concatMap((data: any) => {
          const metadataContent = (typeof (data.Content) === 'string') ?
            JSON.parse(data.Content) as CommandMetadataContent :
            data.Content as CommandMetadataContent;
          this.commandMetatadataContentCache.set(id, metadataContent);
          return of(metadataContent);
        })
      );
  }

  public getServiceMetadataContent(id: string): Observable<ServiceMetadataContent> {
    if (this.serviceMetatadataContentCache.has(id)) {
      return of(this.serviceMetatadataContentCache.get(id));
    }
    const controllerUri = `/platform/common/web/@farris/controllers/services/${id}.webcmp.json`;
    return this.httpClient.get(controllerUri)
      .pipe(
        concatMap((data: any) => {
          const metadataContent = (typeof (data.Content) === 'string') ?
            JSON.parse(data.Content) as ServiceMetadataContent :
            data.Content as ServiceMetadataContent;
          this.serviceMetatadataContentCache.set(id, metadataContent);
          return of(metadataContent);
        })
      );
  }
}
